import React, { useEffect, useState } from "react";
import FilterOption from "./FilterOption";

function FilterBox({filter, onChange}) {

    const [items, setItems] = useState(filter?.items || []);
    const [allItems] = useState(filter?.items || []);
    const [selectedValues, setSelectedValues] = useState([]);
    const [viewOptions, setViewOptions] = useState(false)
    const [last, setLast] = useState('');

    const filterItems = (inputValue) => {
        const search = inputValue.toLowerCase();

        if (!search) {
            setItems(allItems);
        } else {
            const newItems = allItems.filter((item) =>
            item?.name?.toLowerCase().includes(search)
            );
            setItems(newItems);
        }
    };


   function handleFilterChange(itemId, isChecked, last) {
    setSelectedValues((prev) => {
      if (isChecked) {
        if (!prev.includes(itemId)) {
          return [...prev, itemId];
        }
        return prev;
      } else {
        return prev.filter((id) => id !== itemId);
      }
    });

    setLast(last)

  }


    useEffect(()=>{
      if(onChange){
        onChange(filter, selectedValues,last)
      }
    },[selectedValues, viewOptions])


    useEffect(() =>{
      function checkFilter() {
        const url = new URL(window.location);
        const param = url.searchParams.get(filter?.id);
        const values = param ? param.split(",") : [];
        setSelectedValues(values);
      }
      checkFilter()
    },[])

 

  return (
    <div className="flex flex-col items-center px-3 m-3 text-d14 border-dgrey3 rounded-xl border-[1px]">
      <div
        className="flex items-center justify-between w-full uppercase text-dblack2 h-14 cursor-pointer"
        onClick={() => setViewOptions(!viewOptions)}
      >
        <span className="font-medium">{filter.name}</span>
        <span className="text-black text-lg font-semibold">
          {viewOptions ? "−" : "+"}
        </span>
      </div>

      {viewOptions && (
        <div
          className={`w-full flex flex-col gap-2`}
        >
          {/* Search */}
          <input
            type="text"
            onChange={(e) => filterItems(e.target.value)}
            className="border border-dborderblack1 rounded-md px-2 py-1 text-sm outline-none focus:border-dblack2"
            placeholder="Search..."
          />

          {/* Items */}
          
          <div className={`flex flex-col
          ${
            filter?.items.length > 6 ? "overflow-y-auto h-24" : ""
          }`}>
            {items?.map((item, index) => (
              <FilterOption
                filter={filter}
                item={item}
                key={item.id || index}
                onChange={handleFilterChange}
                selected={selectedValues.includes(item?.id)}
              />
            ))}
          </div>
        </div>
      )}
    </div>

  );
}

export default FilterBox;
